module.exports = __webpack_public_path__ + "img/product_banner_web.c2eb0ecd.png";